import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { requestQuestionsclosureData } from '../../../Store/reducers/ClosureQuestions';
import {
  getRegisteredUsers,
  chatHistoryReceived,
  getChatHistory,
  requestAllVehicleLocation,
  isComposeMessageSentSuccessfullyReceived
} from '../../../Store/reducers/RegisteredUsers';
import { useReduxDispatch, useReduxSelector } from '../../../Store/reduxHooks';
import { Badge, Button, Icon } from '../../../Universal/NovusDSImports';
import TableTitle from '../../../SharedComponets/TableTitle';
import { TabItems, TableWrapper } from '../../globalStyles';
import { btnStyles } from '../../../Universal/NovusDSImports/variants';
import { colorState } from '../../../Universal/Foundation';
import { STRINGS } from '../../../Constants/ConstantStrings';
import {
  setShowTableLoader,
  unSelectSelectedRows
} from '../../../Store/reducers/Common';
import {
  debounceFunction,
  getFormattedHeader,
  getOrderingParam,
  getPermission,
  removeEventManagedByLabel,
  showError,
  showPopUp
} from '../../../CommonUtilities/CommonUtilities';
import { RootState } from '../../../store';
import { EmptyUsersListIcon } from '../../../Universal/Assets';
import dayjs from 'dayjs';
import usePrevious from '../../../Hooks/UsePrevious';
import axios from 'axios';
import {
  api_prefix,
  RegisteredUsersTableRowLimit
} from '../../../Constants/constants';
import FileDownload from 'js-file-download';
import RegisteredUsersCarousel from './RegisteredUsersCarousel';
import { FilterBadge, TableSliderStyles } from './styles';
import { TablePopupStyles } from '../../GenericTableComponent/styles';
import { useClickOutside } from '../../../Hooks/useClickOutside';
import { getVehicleStats } from '../../../Store/reducers/Closures';
import PALoader from '../../../SharedComponets/PALoader';
import SearchPhoneNumber from '../SearchPhoneNumber';

const GenericTableRT7 = lazy(
  () => import('../../GenericTableComponent/GenericTable')
);
const ContactHistory = lazy(() => import('./ContactHistory'));
const ConfirmationPopupModal = lazy(
  () => import('../../../SharedComponets/ConfirmationPopupModal')
);
const NoDataFound = lazy(() => import('../../../SharedComponets/NoDataFound'));

const RegisteredUsers = (props: any) => {
  const {
    setMapCenter,
    setIsMessageBoxOpen,
    setSelectedRows,
    selectedRows,
    setselectedRegisteredUser,
    isSideNav,
    selectedRegisteredUser,
    setIsCollapsableMap,
    isMessageBoxOpen,
    activeTabName,
    setActiveTabName,
    getActiveUsersCount,
    isSelectAll,
    setIsSelectAll,
    searchField,
    setSearchField
  } = props;

  const selectedClosure = useReduxSelector(
      (state: RootState) => state.Common.selectedClosure
    ),
    registeredUsersData = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.registeredUsers
    ),
    isComposeMessageSent = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.isComposeMessageSent
    ),
    questionsclosuresData = useReduxSelector(
      (state: RootState) => state.Questions.closuresQuestionsData
    ),
    isShowNewlyAddedQuestionsToUsers = useReduxSelector(
      (state: RootState) => state.Questions.isShowNewlyAddedQuestionsToUsers
    ),
    chatHistoryData = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.chatHistory
    ),
    updatedRegisteredUsersCount = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.updatedRegisteredUsersCount
    ),
    isFetchingRegisteredUsers = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.isFetchingRegisteredUsers
    ),
    currentUser = useReduxSelector(
      (state: RootState) => state.Common.currentUserDetails
    ),
    isRequestingLocationInProgress = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.isRequestingLocation
    ),
    vehicleStats = useReduxSelector(
      (state: RootState) => state.Closures.vehicleStats
    ),
    eventMaintainers = useReduxSelector(
      (state: RootState) => state.Closures.eventMaintainers
    ),
    [selectedUser, setSelectedUser] = useState<any>(null),
    [tableData, setTableData] = useState<null | Array<any>>(null),
    [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false),
    [registerUsersTabs, setRegisterUsersTabs] = useState<any>(false),
    [topVal, setTopVal] = useState<number>(),
    [viewWidth, setViewWidth] = useState<number>(),
    [viewHeight, setViewHeight] = useState<number>(),
    [isLoadingInitialData, setIsLoadingInitialData] = useState<boolean>(true),
    [openStateId, setOpenStateId] = useState<string>(''),
    [isConfirmationModalOpen, setIsConfirmationModalOpen] =
      useState<boolean>(false),
    [selectedFilterParams, setSelectedFilterParams] = useState<any>(null),
    previousIsFetchingRegisteredUsers = usePrevious(isFetchingRegisteredUsers),
    dispatch = useReduxDispatch(),
    [tableSortOrder, setTableSortOrder] = useState<
      Array<{ id: string; desc: boolean }>
    >([]);

  const [isFetchingSitrep, setIsFetchingSitrep] = useState<boolean>(false);

  useEffect(() => {
    if (
      previousIsFetchingRegisteredUsers &&
      !isFetchingRegisteredUsers &&
      isLoadingInitialData
    ) {
      setIsLoadingInitialData(false);
    }
  }, [
    isFetchingRegisteredUsers,
    isLoadingInitialData,
    previousIsFetchingRegisteredUsers
  ]);

  useEffect(() => {
    if (selectedClosure) {
      setSearchField('');
      dispatch(
        getRegisteredUsers({
          closureId: selectedClosure?.id,
          limit: RegisteredUsersTableRowLimit,
          offset: 0,
          search: searchField,
          ordering: getOrderingParam(tableSortOrder)
        })
      );
      if (getPermission(currentUser, 'view_closurequestions')) {
        dispatch(
          requestQuestionsclosureData({
            closureId: selectedClosure?.id,
            limit: 'all'
          })
        );
      }
      dispatch(getVehicleStats({ closureId: selectedClosure?.id }));
    }
  }, [dispatch, selectedClosure, currentUser, tableSortOrder]);

  useEffect(() => {
    if (isComposeMessageSent) {
      setIsMessageBoxOpen(false);
      dispatch(unSelectSelectedRows({ shouldUnselect: true }));
      dispatch(isComposeMessageSentSuccessfullyReceived({ isSent: false }));
    }
  }, [dispatch, isComposeMessageSent, setIsMessageBoxOpen]);

  useEffect(() => {
    setSelectedRows(null);
    setIsSelectAll(false);
    setActiveTabName(null);
    setSelectedFilterParams(null);
    setselectedRegisteredUser(null);
  }, [selectedClosure]);

  useEffect(() => {
    if (registeredUsersData && Object.keys(registeredUsersData)?.length) {
      const data: any = [];
      registeredUsersData?.results?.forEach((user: any) => {
        const userTempData = { ...user };
        questionsclosuresData?.forEach((question: any) => {
          userTempData[question.id] = user.answers && user.answers[question.id];
        });
        data.push(userTempData);
      });
      setTableData(data);
      if (isSelectAll) {
        handleSelectAllClick();
      }
    }
  }, [registeredUsersData, questionsclosuresData]);

  const ContactHistoryPopup = () => {
    setIsTooltipOpen(false);
    const contactHistory = document.getElementById(
      `contact-history-${openStateId}`
    );
    const tdElement = contactHistory?.closest('td');
    if (tdElement) {
      tdElement.classList.remove('selected-td');
    }
  };

  useEffect(() => {
    const selectedPhoneNumberList = document.querySelectorAll(
      '#user-mobile-number'
    );
    for (let i = 0; i < selectedPhoneNumberList.length; i++) {
      const tdElement = selectedPhoneNumberList[i]?.closest('td');
      //only the selected phone number will get that classname added
      if (
        selectedPhoneNumberList[i].innerHTML ===
        selectedRegisteredUser?.phone_number
      ) {
        if (tdElement) {
          tdElement.classList.add('selected-td');
        }
      }
      //except selected number, for all remaining numbers will remove classname
      else {
        tdElement?.classList.remove('selected-td');
      }
    }
  }, [selectedRegisteredUser]);

  const handleClick = (user: any) => {
    if (user.is_active) {
      if (user?.location && user.location.coordinates?.length) {
        setMapCenter({
          lat: user.location.coordinates[0],
          lng: user.location.coordinates[1]
        });
        setselectedRegisteredUser(user);
        setIsCollapsableMap(true);
      } else {
        showPopUp('Selected User has not provided location', 'info');
        setMapCenter({
          lat: selectedClosure?.centre_latitude,
          lng: selectedClosure?.centre_longitude
        });
        setselectedRegisteredUser(null);
      }
    } else {
      setselectedRegisteredUser(null);
      showPopUp(STRINGS.SELECTED_USER_GOT_UNREGISTERED, 'info');
    }
  };

  const selectedRegisteredUserRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedRegisteredUserRef.current) {
      selectedRegisteredUserRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [selectedRegisteredUser]);

  const setColumns = () => {
    const columns: any = [
      {
        Header: 'Phone#',
        accessor: 'phone_number',
        Cell: ({ row }) => (
          <div
            className={'link'}
            id="user-mobile-number"
            role="button"
            tabIndex={0}
            aria-label={`select the phone number ${row.original.phone_number} to locate them on map`}
            onClick={() => {
              handleClick(row.original);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleClick(row.original);
              }
            }}
            ref={
              selectedRegisteredUser?.phone_number === row.original.phone_number
                ? selectedRegisteredUserRef
                : null
            }
          >
            {row.original.phone_number}
          </div>
        ),
        label: ({ row }) =>
          STRINGS.PHONE_NUMBER + ' : ' + row.original.phone_number
      },
      {
        Header: 'Location Enabled',
        id: 'location_enabled',
        accessor: 'inside_zone',
        Cell: (data: any) => {
          return (
            <div>
              {data.row.original.inside_zone !== null
                ? STRINGS.YES
                : STRINGS.NO}
            </div>
          );
        },
        label: ({ row }) =>
          `Location Enabled : ${
            row.original.inside_zone !== null ? STRINGS.YES : STRINGS.NO
          }`
      },
      {
        Header: 'Inside Zone',
        accessor: 'inside_zone',
        sortType: (rowA: any, rowB: any, columnId: any) => {
          const insideZoneA = rowA.values[columnId];
          const insideZoneB = rowB.values[columnId];
          const valueA = insideZoneA === null ? 2 : insideZoneA ? 1 : 0;
          const valueB = insideZoneB === null ? 2 : insideZoneB ? 1 : 0;
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        },
        Cell: (data: any) => (
          <div>
            {data.row.original.inside_zone !== null
              ? data.row.original.inside_zone
                ? STRINGS.YES
                : STRINGS.NO
              : STRINGS.LOCATION_NOT_SHARED}
          </div>
        ),
        label: ({ row }) => `
          Inside Zone : ${
            row.original.inside_zone !== null
              ? row.original.inside_zone
                ? STRINGS.YES
                : STRINGS.NO
              : STRINGS.LOCATION_NOT_SHARED
          }
        `
      },
      {
        Header: 'Contacted By',
        accessor: 'contact_by',
        disableSortBy: true,
        label: ({ row }) => `Contacted By : ${row.original.contact_by || 'N/A'}`
      }
    ];
    if (questionsclosuresData?.length)
      questionsclosuresData.forEach((question: any, index: number) => {
        columns.push({
          Header: getFormattedHeader(question.abbr_name),
          id: index,
          accessor: (data: any) => data[question.id],
          disableSortBy: true,
          label: ({ row }) =>
            `${getFormattedHeader(question.abbr_name)} : ${
              row.original[question.id] || 'N/A'
            }`
        });
      });
    columns.push({
      Header: 'Last Contacted',
      accessor: 'last_contacted_time',
      Cell: (data: any) => {
        return (
          <div>
            {data.row.original.last_contacted_time
              ? dayjs(data.row.original.last_contacted_time).format(
                  'MM/DD/YYYY  hh:mm A'
                )
              : 'N/A'}
          </div>
        );
      },
      disableSortBy: true,
      label: ({ row }) =>
        `Last Contacted : ${
          row.original.last_contacted_time
            ? dayjs(row.original.last_contacted_time).format(
                'MM/DD/YYYY  hh:mm A'
              )
            : 'N/A'
        }`
    });

    window.addEventListener('resize', () => {
      ContactHistoryPopup();
      setRegisterUsersTabs(false);
    });

    const Table = document.getElementById('register-user-table');
    if (Table) {
      Table.addEventListener('wheel', () => {
        // 'wheel' this can be used not only for scroll event also it works for zooming.
        ContactHistoryPopup();
        setRegisterUsersTabs(false);
      });
    }

    const ContactHistoryCoordinates = (id: any) => {
      const contactHistory = document
        .getElementById(`contact-history-${id}`)
        ?.closest('td');
      setOpenStateId(id);
      const top: any =
        contactHistory && contactHistory.getBoundingClientRect().top;
      setTopVal(top);
      const width: any =
        contactHistory && contactHistory.getBoundingClientRect().width;
      setViewWidth(width);
      const height: any =
        contactHistory && contactHistory.getBoundingClientRect().height;
      setViewHeight(height);

      const tdElement = contactHistory?.closest('td');
      if (tdElement) {
        tdElement.classList.add('selected-td');
      }
      setIsTooltipOpen(true);
    };

    columns.push({
      Header: 'Contact History',
      Cell: (data: any) => {
        return (
          <div id={`contact-history-${data.row.original.id}`}>
            {data.row.original.last_contacted_time ? (
              <>
                <div
                  aria-label="View-contact-history"
                  tabIndex={0}
                  className={'view-details-section link'}
                  data-testid={`view contact history of ${data.row.original.phone_number}`}
                  onClick={() => {
                    if (data.row.original.id !== selectedUser?.id) {
                      ContactHistoryPopup();
                    }
                    if (
                      data.row.original.last_contacted_time &&
                      getPermission(currentUser, 'view_chatmessage')
                    ) {
                      ContactHistoryCoordinates(data.row.original.id);
                      setSelectedUser(data.row.original);
                      dispatch(
                        getChatHistory({ userId: data.row.original.id })
                      );
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      if (
                        data.row.original.last_contacted_time &&
                        getPermission(currentUser, 'view_chatmessage')
                      ) {
                        ContactHistoryCoordinates(data.row.original.id);
                        setSelectedUser(data.row.original);
                        dispatch(
                          getChatHistory({ userId: data.row.original.id })
                        );
                      }
                    }
                  }}
                >
                  {STRINGS.VIEW}
                </div>
              </>
            ) : (
              STRINGS.NO_VALUE
            )}

            {isTooltipOpen && data.row.original.id === selectedUser.id && (
              <ContactHistory
                selectedUser={selectedUser}
                chatHistory={chatHistoryData}
                setSelectedUser={setSelectedUser}
                setIsTooltipOpen={setIsTooltipOpen}
                topVal={topVal}
                onPopupClose={onPopupClose}
                viewWidth={viewWidth}
                viewHeight={viewHeight}
                ContactHistoryPopup={ContactHistoryPopup}
                searchField={searchField}
              />
            )}
          </div>
        );
      },
      disableSortby: true,
      label: ({ row }) =>
        `Contact History ${
          row.original.last_contacted_time ? '' : STRINGS.NO_VALUE
        }`
    });
    return columns;
  };

  const onPopupClose = () => {
    setIsTooltipOpen(false);
    dispatch(chatHistoryReceived({ chatHistory: null }));
    setSelectedUser(null);
  };

  const handleFilter = (filter: string, abbr_name: string, usersData: any) => {
    setActiveTabName(filter);
    setSelectedFilterParams({ filter: filter, abbr_name: abbr_name });
    setselectedRegisteredUser(null);
    setSelectedRows(null);
    setIsSelectAll(false);
    const data: any = {};
    let questionId: number;
    questionsclosuresData?.forEach((question) => {
      if (question.abbr_name === abbr_name) questionId = question.id;
    });
    usersData?.forEach((user: any, index: number) => {
      if (user.is_active) {
        if (filter !== 'not_yet_contacted') {
          if (
            questionId &&
            user.answers &&
            user.answers[questionId] === filter
          ) {
            data[index] = true;
          }
        } else {
          if (!user.last_contacted_time) {
            data[index] = true;
          }
        }
      }
    });
    setSelectedRows(data);
    setIsSelectAll(data && Object.keys(data) === usersData.length);
  };

  const getFilteredRegisteredUsersData = (
    filter: string,
    abbr_name?: string
  ) => {
    dispatch(
      getRegisteredUsers({
        closureId: selectedClosure?.id,
        limit: RegisteredUsersTableRowLimit,
        custom_ordering: filter,
        abbr_name: abbr_name || '',
        onCompleteAction: handleFilter,
        offset: 0,
        search: searchField,
        ordering: getOrderingParam(tableSortOrder)
      })
    );
  };

  const getUpdatedUsersData = () => {
    setSelectedRows({});
    setIsSelectAll(false);
    setActiveTabName(null);
    setSelectedFilterParams(null);
    dispatch(
      getRegisteredUsers({
        closureId: selectedClosure?.id,
        limit: RegisteredUsersTableRowLimit,
        offset: 0,
        search: searchField,
        ordering: getOrderingParam(tableSortOrder)
      })
    );
  };

  const customConfirmationStyles = {
    content: {
      minWidth: '15%',
      minHeight: '10vh'
    },
    overlay: {
      backgroundColor: 'rgba(114, 114, 114, 0.294)'
    }
  };

  const handleAllVehicleLocationRequestClick = () => {
    setIsConfirmationModalOpen(true);
  };

  const onSendClick = () => {
    dispatch(
      requestAllVehicleLocation({
        closureId: selectedClosure?.id,
        postModalClose: postModalClose
      })
    );
  };

  const postModalClose = () => {
    setIsConfirmationModalOpen(false);
  };

  const handleSelectAllClick = () => {
    if (
      selectedRows &&
      Object.keys(selectedRows).length &&
      Object.keys(selectedRows).length === getActiveUsersCount()
    ) {
      setSelectedRows({});
      setIsSelectAll(false);
    } else {
      const data = {};
      registeredUsersData?.results?.forEach((user: any, index: number) => {
        if (user.is_active) data[index] = true;
      });
      setSelectedRows(data);
      setIsSelectAll(true);
    }
    if (activeTabName) {
      setActiveTabName(null);
      setSelectedFilterParams(null);
    }
  };

  const handleSelectCheckBoxClick = (index: number) => {
    const data = { ...selectedRows };
    if (selectedRows && selectedRows[index]) {
      delete data[index];
    } else {
      data[index] = true;
    }
    setActiveTabName(null);
    setSelectedFilterParams(null);
    setSelectedRows(data);
    setIsSelectAll(
      data && Object.keys(data) === registeredUsersData?.results?.length
    );
  };

  const handleClear = () => {
    if ((selectedRows && Object.keys(selectedRows)?.length) || activeTabName) {
      setIsMessageBoxOpen(false);
      setSelectedRows(null);
      setIsSelectAll(false);
      setActiveTabName(null);
      setSelectedFilterParams(null);
      setselectedRegisteredUser(null);
      getUpdatedUsersData();
    }
  };

  const renderNewlyAddedFilter = () => {
    return (
      <TabItems
        tabIndex={0}
        id={`tab-${STRINGS.NEWLY_ADDED_ONLY}`}
        onClick={() => getFilteredRegisteredUsersData('not_yet_contacted')}
        selectedtab={activeTabName === STRINGS.NEWLY_ADDED_ONLY}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            getFilteredRegisteredUsersData('not_yet_contacted');
          }
        }}
        aria-label={STRINGS.NEWLY_ADDED_ONLY}
        title={STRINGS.NEWLY_ADDED_ONLY}
      >
        <span className="text-truncate">{STRINGS.NEWLY_ADDED_ONLY}</span>
        <FilterBadge filterName={'not_yet_contacted'}>
          {vehicleStats?.contacted_stats?.['not_yet_contacted']}
        </FilterBadge>
      </TabItems>
    );
  };

  const renderConfirmationFooter = () => {
    return (
      <div className="gap-3 d-flex">
        <Button onClick={postModalClose} {...btnStyles.default}>
          {STRINGS.CANCEL}
        </Button>
        <Button
          onClick={onSendClick}
          {...btnStyles.danger}
          disabled={isRequestingLocationInProgress}
          aria-disabled={isRequestingLocationInProgress}
        >
          {STRINGS.SEND}
        </Button>
      </div>
    );
  };

  const NoRegisteredUsersData = () => {
    return (
      <NoDataFound
        src={EmptyUsersListIcon}
        description={STRINGS.NO_REGISTERED_USERS}
        alt={'no-registered-users-img'}
        isAbsolute
        subMsgDescription="Your list of users are empty because no one has registered for the event yet."
        imgWidth={60}
        imgHeight={60}
        testId="no-registered-users"
      />
    );
  };

  const openRegisterUsersTabs = () => {
    setRegisterUsersTabs(!registerUsersTabs);
  };

  const openStateElement = useRef<HTMLDivElement | null>(null);
  const excludedElement: any = useRef([]);
  const popupButtonRef = useRef<HTMLButtonElement>(null);
  useClickOutside(openStateElement, openRegisterUsersTabs, [excludedElement]);
  const timerToSaveDetails = useRef<NodeJS.Timeout | null>(null);
  const [popupStyles, setPopupStyles] = useState<any>({
    zIndex: 1000,
    top: 0,
    left: 0,
    width: 'max-content',
    position: 'fixed',
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out'
  });

  useEffect(() => {
    if (
      registerUsersTabs &&
      popupButtonRef.current &&
      openStateElement.current
    ) {
      const buttonRect = popupButtonRef.current.getBoundingClientRect();
      const popupElement = openStateElement.current as HTMLElement;
      const popupWidth = popupElement.offsetWidth || 180; // fallback to min-width

      const spaceOnRight = window.innerWidth - buttonRect.right;
      const spaceOnLeft = buttonRect.left;

      // Position on the left if not enough space on the right
      if (spaceOnRight < popupWidth && spaceOnLeft > popupWidth) {
        setPopupStyles({
          zIndex: 1000,
          top: buttonRect.bottom + 5,
          left: buttonRect.right - popupWidth,
          width: 'max-content',
          position: 'fixed',
          opacity: 1,
          transition: 'opacity 0.2s ease-in-out'
        });
      } else {
        // Default: position on the right
        setPopupStyles({
          zIndex: 1000,
          top: buttonRect.bottom + 5,
          left: buttonRect.left,
          width: 'max-content',
          position: 'fixed',
          opacity: 1,
          transition: 'opacity 0.2s ease-in-out'
        });
      }
    } else {
      // Reset opacity when closed
      setPopupStyles((prev) => ({
        ...prev,
        opacity: 0
      }));
    }
  }, [registerUsersTabs]);

  useEffect(() => {
    const slick = document.querySelector('.slick-track');
    const slickSlide = document.querySelectorAll('.slick-slide');
    if (slick) {
      slick.setAttribute('role', 'tablist');
    }
    slickSlide.forEach((slide) => {
      slide.setAttribute('role', 'tab');
    });
  }, [registerUsersTabs]);

  useEffect(() => {
    debounceFunction(timerToSaveDetails, 100, () => {
      dispatch(
        getRegisteredUsers({
          closureId: selectedClosure?.id,
          limit: RegisteredUsersTableRowLimit,
          offset: 0,
          search: searchField,
          ordering: getOrderingParam(tableSortOrder)
        })
      );
    });
  }, [searchField]);

  useEffect(() => {
    if (!isFetchingRegisteredUsers) {
      dispatch(setShowTableLoader({ showTableLoader: false }));
      setIsLoadingInitialData(false);
    }
  }, [isLoadingInitialData, isFetchingRegisteredUsers, tableSortOrder]);

  const getNextSetOfData = (offset: number) => {
    if (activeTabName) {
      dispatch(
        getRegisteredUsers({
          closureId: selectedClosure?.id,
          limit: RegisteredUsersTableRowLimit,
          custom_ordering: selectedFilterParams?.filter,
          abbr_name: selectedFilterParams?.abbr_name || '',
          onCompleteAction: handleFilter,
          offset: offset,
          shouldAppend: true,
          search: searchField,
          ordering: getOrderingParam(tableSortOrder)
        })
      );
    } else {
      dispatch(
        getRegisteredUsers({
          closureId: selectedClosure?.id,
          limit: RegisteredUsersTableRowLimit,
          offset: offset,
          shouldAppend: true,
          search: searchField,
          ordering: getOrderingParam(tableSortOrder)
        })
      );
    }
  };

  useEffect(() => {
    if (registerUsersTabs && openStateElement.current) {
      const firstTabbable =
        openStateElement.current.querySelector<HTMLElement>('[tabindex="0"]');

      firstTabbable?.focus();
    }
  }, [registerUsersTabs]);

  const handleSITREPDownload = async () => {
    if (!isFetchingSitrep) {
      setIsFetchingSitrep(true);
      await axios
        .get(
          `${api_prefix}closures/${selectedClosure?.id}/get_situation_report/`,
          { responseType: 'blob' }
        )
        .then((response) => {
          FileDownload(
            response.data,
            `SituationReport_${selectedClosure?.id}_${dayjs().format(
              'YYYYMMDDHHmmss'
            )}.pdf`
          );
          setIsFetchingSitrep(false);
        })
        .catch((err) => {
          showError(err);
          setIsFetchingSitrep(false);
        });
    }
  };

  const handlePortalTabKeyDown = (
    e: React.KeyboardEvent,
    elementID: string
  ) => {
    e.preventDefault();
    document.getElementById(elementID)?.focus();
    openRegisterUsersTabs();
  };

  return (
    <TableWrapper
      id="table-group"
      className="register-users-table"
      data-testid="register-users-page"
    >
      <TableTitle
        title={STRINGS.REGISTERED_USERS}
        message={
          selectedClosure &&
          removeEventManagedByLabel(
            selectedClosure?.wea_short_msg_english,
            eventMaintainers
          )
        }
      >
        {getPermission(currentUser, 'outbound_message_frontend') &&
        registeredUsersData?.results?.length ? (
          <Button
            title="Compose Message"
            data-testid="compose-message"
            onClick={() => {
              if (
                !selectedRows ||
                !(selectedRows && Object.keys(selectedRows).length)
              ) {
                showPopUp(
                  STRINGS.PLEASE_SELECT_ATLEAST_ONE_USER_TO_SEND_MESSAGE,
                  'error'
                );
              } else {
                ContactHistoryPopup();
                setIsMessageBoxOpen(true);
              }
            }}
            {...btnStyles.primary}
          >
            <Icon
              icon={'message'}
              stroke={colorState.icon.default['primary-inverse']}
              width={'16px'}
              height={'16px'}
              aria-label="Compose message icon"
            />
            {STRINGS.COMPOSE_MESSAGE}
          </Button>
        ) : null}
      </TableTitle>
      {!isLoadingInitialData ? (
        <TableSliderStyles
          isSideNav={isSideNav}
          registerUsersTabs={registerUsersTabs}
        >
          {vehicleStats && Object.keys(vehicleStats)?.length > 1 ? (
            <RegisteredUsersCarousel
              vehicleStats={vehicleStats}
              isSideNav={isSideNav}
              activeTabName={activeTabName}
              onFilterClick={getFilteredRegisteredUsersData}
              onClear={handleClear}
            />
          ) : (
            renderNewlyAddedFilter()
          )}

          <div className="right-wrapper d-flex gap-2">
            <div className="position-relative">
              <div
                className={`${
                  isMessageBoxOpen
                    ? 'compose-more-options'
                    : 'more-options-tabs d-none'
                } `}
              >
                <div
                  className="d-flex align-items-center gap-3"
                  id="register-users-tabs"
                >
                  {updatedRegisteredUsersCount >
                    registeredUsersData?.results?.length && (
                    <TabItems
                      tabIndex={0}
                      onClick={getUpdatedUsersData}
                      className="participant-variant-tab text-nowrap"
                      selectedtab={activeTabName === getUpdatedUsersData}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          getUpdatedUsersData();
                        }
                      }}
                      defaultTextColor
                      defaultRadius
                    >
                      {<Icon icon={'user_01'} />}
                      <Badge variant="info" style={{ fontSize: '12px' }}>
                        {updatedRegisteredUsersCount -
                          (registeredUsersData &&
                            Object.keys(registeredUsersData).length &&
                            registeredUsersData.results?.length)}{' '}
                      </Badge>
                    </TabItems>
                  )}
                  <button
                    id="more-options-menu"
                    aria-label="More options menu"
                    className="option-icon"
                    data-testid="extra-options"
                    ref={(el) => {
                      excludedElement.current = el;
                      if (popupButtonRef.current !== el) {
                        (
                          popupButtonRef as React.MutableRefObject<HTMLButtonElement | null>
                        ).current = el;
                      }
                    }}
                    tabIndex={0}
                    onClick={openRegisterUsersTabs}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' && !event.repeat) {
                        event.preventDefault();
                        openRegisterUsersTabs();
                      }
                    }}
                  >
                    <Icon icon={'dots_vertical'} width="20px" height="20px" />
                  </button>
                </div>
                {registerUsersTabs &&
                  createPortal(
                    <TablePopupStyles
                      style={popupStyles}
                      ref={openStateElement}
                    >
                      <ul data-testid="extra-options-list">
                        {registeredUsersData?.results?.length &&
                        getPermission(currentUser, 'users_location_request') ? (
                          <li
                            tabIndex={0}
                            data-testid="request-all-vehicle-locations"
                            id={`tab-${STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}`}
                            onClick={handleAllVehicleLocationRequestClick}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter') {
                                handleAllVehicleLocationRequestClick();
                              } else if (
                                event.key === 'Tab' &&
                                event.shiftKey
                              ) {
                                handlePortalTabKeyDown(
                                  event,
                                  'more-options-menu'
                                );
                              }
                            }}
                            aria-label={STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                            title={STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                          >
                            <Icon
                              icon="refresh_ccw_02"
                              stroke={colorState.icon.default.tertiary}
                              width={16}
                              height={16}
                              className="me-2"
                              aria-label="Request all vehicle locations"
                            />
                            {STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                          </li>
                        ) : null}
                        <li
                          id="download-sitrep-tab"
                          role="tab"
                          data-testid="download-sitrep"
                          tabIndex={0}
                          className={`${isFetchingSitrep ? 'disabled' : ''}`}
                          onClick={handleSITREPDownload}
                          title="SITREP"
                          aria-label="Download situation report"
                          aria-disabled={isFetchingSitrep}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleSITREPDownload();
                            } else if (
                              !(
                                Object.keys(selectedRows ?? {}).length > 0 ||
                                activeTabName
                              ) &&
                              e.key === 'Tab' &&
                              !e.shiftKey
                            ) {
                              handlePortalTabKeyDown(
                                e,
                                'phone-number-search-input'
                              );
                            } else if (
                              !registeredUsersData?.results?.length &&
                              e.key === 'Tab' &&
                              e.shiftKey
                            ) {
                              handlePortalTabKeyDown(e, 'more-options-menu');
                            }
                          }}
                        >
                          <Icon
                            icon="file_06"
                            stroke={
                              isFetchingSitrep
                                ? colorState.icon.default.disabled
                                : colorState.icon.default.tertiary
                            }
                            width={16}
                            height={16}
                            className="me-2"
                            aria-label="Download situation report"
                          />
                          {STRINGS.SITREP}
                        </li>
                        {(Object.keys(selectedRows ?? {}).length > 0 ||
                          activeTabName) && (
                          <li
                            role="tab"
                            data-testid="clear-tab"
                            tabIndex={0}
                            onClick={handleClear}
                            className="table-clear-tab"
                            onKeyDown={(event) => {
                              if (event.key === 'Enter') {
                                handleClear();
                                document
                                  .getElementById('download-sitrep-tab')
                                  ?.focus();
                              } else if (
                                event.key === 'Tab' &&
                                !event.shiftKey
                              ) {
                                handlePortalTabKeyDown(
                                  event,
                                  'phone-number-search-input'
                                );
                              }
                            }}
                            aria-label="clear-tab"
                          >
                            <Icon
                              icon={'eraser'}
                              className="eraser-icon me-2"
                              stroke={colorState.icon.default.secondary}
                              width={16}
                              height={16}
                              alt="eraser-icon"
                              aria-label="Clear user selections"
                            />
                            {STRINGS.CLEAR}
                          </li>
                        )}
                      </ul>
                    </TablePopupStyles>,
                    document.body
                  )}
              </div>
              <div
                className={`${
                  !isMessageBoxOpen && 'right-wrapper-tabs'
                } d-none`}
              >
                {!!registeredUsersData?.results?.length &&
                  getPermission(currentUser, 'users_location_request') && (
                    <TabItems
                      tabIndex={0}
                      id={`tab-${STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}`}
                      onClick={handleAllVehicleLocationRequestClick}
                      selectedtab={isConfirmationModalOpen}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          handleAllVehicleLocationRequestClick();
                        }
                      }}
                      aria-label={STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                      title={STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                      defaultTextColor
                      defaultRadius
                    >
                      <Icon
                        icon="refresh_ccw_02"
                        stroke={colorState.icon.default.tertiary}
                        width={16}
                        height={16}
                        aria-label="Request all vehicle locations"
                      />
                      <span className="vehicle-location">
                        {STRINGS.REQUEST_ALL_VEHICLE_LOCATIONS}
                      </span>
                    </TabItems>
                  )}
                {getPermission(currentUser, 'download_situation_report') && (
                  <TabItems
                    tabIndex={0}
                    onClick={async () => {
                      if (!isFetchingSitrep) {
                        setIsFetchingSitrep(true);
                        await axios
                          .get(
                            `${api_prefix}closures/${selectedClosure?.id}/get_situation_report/`,
                            { responseType: 'blob' }
                          )
                          .then((response) => {
                            FileDownload(
                              response.data,
                              `SituationReport_${
                                selectedClosure?.id
                              }_${dayjs().format('YYYYMMDDHHmmss')}.pdf`
                            );
                            setIsFetchingSitrep(false);
                          })
                          .catch((err) => {
                            showError(err);
                            setIsFetchingSitrep(false);
                          });
                      }
                    }}
                    title="SITREP"
                    disabled={isFetchingSitrep}
                    aria-label="Download situation report"
                    aria-disabled={isFetchingSitrep}
                    defaultTextColor
                    defaultRadius
                  >
                    <Icon
                      icon="file_06"
                      stroke={
                        isFetchingSitrep
                          ? colorState.icon.default.disabled
                          : colorState.icon.default.tertiary
                      }
                      width={16}
                      height={16}
                      aria-label="Download situation report"
                    />
                    SITREP
                  </TabItems>
                )}
                {updatedRegisteredUsersCount >
                  registeredUsersData?.results?.length && (
                  <TabItems
                    tabIndex={0}
                    onClick={getUpdatedUsersData}
                    className="participant-variant-tab text-nowrap"
                    selectedtab={activeTabName === getUpdatedUsersData}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        getUpdatedUsersData();
                      }
                    }}
                    defaultTextColor
                    defaultRadius
                  >
                    {<Icon icon={'user_01'} aria-label="Updated users" />}
                    <Badge variant="info" style={{ fontSize: '12px' }}>
                      {updatedRegisteredUsersCount -
                        (registeredUsersData &&
                          registeredUsersData?.results?.length)}{' '}
                    </Badge>
                  </TabItems>
                )}
                {(Object.keys(selectedRows ?? {}).length > 0 ||
                  activeTabName) && (
                  <TabItems
                    tabIndex={0}
                    onClick={handleClear}
                    className="table-clear-tab"
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        handleClear();
                      }
                    }}
                    aria-label="clear-tab"
                    defaultTextColor
                    defaultRadius
                  >
                    <Icon
                      icon={'eraser'}
                      className="eraser-icon"
                      stroke={colorState.icon.default.secondary}
                      width={16}
                      height={16}
                      alt="eraser-icon"
                      aria-label="Clear user selections"
                    />
                    {STRINGS.CLEAR}
                  </TabItems>
                )}
              </div>
            </div>
            <SearchPhoneNumber
              searchField={searchField}
              setSearchField={setSearchField}
            />
          </div>
        </TableSliderStyles>
      ) : null}
      <div
        className="w-100 d-flex overflow-auto flex-grow-1 flex-column"
        id={'register-user-table'}
        data-testid="register-user-table"
      >
        {isLoadingInitialData ? (
          <PALoader />
        ) : (
          <Suspense fallback={<PALoader />}>
            <GenericTableRT7
              columns={tableData?.length ? setColumns() : []}
              tableData={tableData || []}
              setSelectedRows={setSelectedRows}
              showCheckBoxColumn={tableData?.length ? true : false}
              shouldFocusColumnOfRow
              checkBoxColumnText={'S. No'}
              defaultAllColumnsSelected={isShowNewlyAddedQuestionsToUsers}
              selectedRows={selectedRows}
              noDataFoundScreen={NoRegisteredUsersData()}
              customSelectAllCheckBoxLogic={handleSelectAllClick}
              customSingleCheckBoxLogic={handleSelectCheckBoxClick}
              isRegisteredUsers={true}
              activeUsersCount={getActiveUsersCount()}
              infiniteScrollSettings={{
                getNextSetOfData,
                pageSize: 8,
                totalCount: registeredUsersData?.meta?.count
              }}
              defaultSorted={tableSortOrder}
              setSelectedSortOrder={setTableSortOrder}
            />
          </Suspense>
        )}
      </div>
      <ConfirmationPopupModal
        isOpen={isConfirmationModalOpen}
        description={STRINGS.ARE_YOU_SURE}
        customFooter={true}
        showFooter={renderConfirmationFooter()}
        showHeader={false}
        closeModal={postModalClose}
        showBorderTop={false}
        isBodyPaddingNone={true}
        style={customConfirmationStyles}
      />
    </TableWrapper>
  );
};

export default RegisteredUsers;
